import { render, staticRenderFns } from "./DocalDocumentPicker.vue?vue&type=template&id=13ac7f46&scoped=true&"
import script from "./DocalDocumentPicker.vue?vue&type=script&lang=js&"
export * from "./DocalDocumentPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocalDocumentPicker.vue?vue&type=style&index=0&id=13ac7f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac7f46",
  null
  
)

export default component.exports